<template>
    <div class="air_ListBox">
        <div class="search-form">
            <el-row type="flex" :gutter="20" align="middle">
                <el-col class="el-col-label" :span="8">
                    <span>票号:</span>
                    <input
                        clearable
                        v-model="searchForm.ticketNumber"
                        @keyup.13="search"
                        @clear="searchClear"
                    >
                </el-col>
                <el-col class="el-col-label" :span="8">
                    <span>乘客:</span>
                    <input
                        clearable
                        v-model="searchForm.passengerName"
                        @keyup.13="search"
                        @clear="searchClear"
                    >
                </el-col>
                <el-col class="el-col-label" :span="8">
                    <span>废票时间:</span>
                    <el-date-picker
                        v-model="searchForm.startInvDate"
                        :picker-options='selectPickerOptions()'
                        type="date"
                        class="time_box"
                        value-format="yyyy-MM-dd"
                        @change="search"
                    ></el-date-picker>
                </el-col>
            </el-row>
            <div class="btn_box">
                <el-button type="primary" @click="search" size="small">搜索</el-button>
                <el-button  @click="reset" size="small">重置</el-button>
            </div>
        </div>
        <el-row>
            <el-col :span="24">
                <div class="table-nav flex-center">
          <div class="nav-item cursor"
               v-for="(item,index) in changeRecordList"
               :key="index"
               :class="{'nav-item-active':NavItemActive==index}"
               @click="statuSearch(item,index)">
               {{item.text}}
          </div>
         </div>

        <el-table :data="pageData" v-loading="loading" style="width: 100%" v-if="pageData">
          <el-table-column label="订单号" width="200" class-name="fz12">
            <template slot-scope="scope">
                <p>{{scope.row.orderNo}}</p>
            </template>
          </el-table-column>
          <el-table-column label="航班号/行程/舱位/日期" width="200" class-name="fz12">
            <template slot-scope="scope">
              <div
                v-for="(segmentEntity,segmentEntityIndex) in scope.row.routeList"
                :key="segmentEntityIndex"
              >
                <p>行程：{{segmentEntity.sCityName}}/{{segmentEntity.eCityName}}</p>
                <p>航班号：{{segmentEntity.flightNo}}</p>
                <p>舱位：{{segmentEntity.cabinCode}}</p>
                <p>日期：{{segmentEntity.beginDate}}/{{segmentEntity.beginTime}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="乘机人/票号" width="100" class-name="fz12">
            <template slot-scope="scope">
              <div
                v-for="(passengerEntity,passengerEntityIndex) in scope.row.passengers"
                :key="passengerEntityIndex"
              >{{parseInt(passengerEntityIndex) + 1}}.{{passengerEntity.lastName+'/'+passengerEntity.firstName}}
              <span v-if="passengerEntity.ticketNumber">({{passengerEntity.ticketNumber}})</span>
              </div>
            </template>
          </el-table-column>
           <el-table-column label="废票时间" width="150" class-name="fz12">
            <template slot-scope="scope">
              {{scope.row.appTime}}
            </template>
          </el-table-column>
          <el-table-column label="退款金额" class-name="fz12">
            <template slot-scope="scope"> <span class="font-10">￥</span>{{Number(scope.row.toPrice).toFixed(2)}}</template>
          </el-table-column>
          <el-table-column label="状态" width="80" class-name="fz12">
            <template slot-scope="scope">
              {{scope.row.invStatus==61?'处理中':
              scope.row.invStatus==62?'已作废':
              scope.row.invStatus==63?'废票失败':
              ''}}</template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" class-name="fz12">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="setOrdersNo(scope.row,'changPay')"
              >查看订单
              </el-button>

            </template>
          </el-table-column>
         </el-table>
                <div style="margin-bottom: 10px;"></div>
                <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                background
                @size-change="handlerSize"
                @current-change="handlerPage"
                :current-page="searchForm.currentPage"
                :page-sizes="[10,20,30,40,50]"
                :page-size="10"
                :page-count="searchForm.pageSize"
                :total="totalCount"
                ></el-pagination>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import scrollTop from '@/lib/common-service/scrollTop'
import list from '@/lib/data-service/flight/fligthInternationalAdmin/flight_inter_buyer_manage_order_findVoidOrderList.js'
export default {
  data() {
    return {
      searchForm: {
        currentPage:1,
        pageSize:10
      },
      totalCount:0,
      flightAirlines: [],
      changeRecordList:[
        {text:'全部',value:''},
        {text:'处理中',value:61},
        {text:'已作废',value:62},
        {text:'废票失败',value:63},
      ],
      NavItemActive:'',
      pageData:[],
      loading:false,
    };
  },
  created(){
    this.search()
  },
  methods: {
    statuSearch(item,index){
       this.NavItemActive = index
       this.searchForm.invStatus = item.value
       this.search()
    },
    searchClear() {

    },
    // 日期选择
    selectPickerOptions() {
      return {
        disabledDate: time => {
            return time.getTime() > Date.now()
        }
      }
    },
    reset() {
      this.searchForm = {currentPage:1,pageSize:10}
    },
    search(pageNum) {
      let data = this.searchForm
      if(typeof pageNum == 'number'){
          data.currentPage = pageNum||1
      }else{
        data.currentPage = 1
      }
      data.startInvDate?data.endInvDate = this.$moment().format('YYYY-MM-DD'):data.endInvDate = ''
      list(data).then(res=>{
        this.pageData = res.pageResult.pageData
        this.totalCount = res.pageResult.totalCount
        scrollTop(500)
      })
    },
    setOrdersNo(item,type){
      console.log(item)
      this.$router.push({name:'air-ticket-admin-international-list-order-detail',
             query:{ordersNo:item.invalidId,type:type},params:{refresh:1}})
    },

    handlerSize(val){
      this.searchForm.pageSize = val
      this.search()
    },
    handlerPage(val){
      // this.searchForm.currentPage = val
      this.search(val)
    }
  }
};
</script>

<style lang='less' scoped>
@import "./css/common";
</style>
